<script>
    import { computed } from 'vue';
    import { truncText } from '../../utils/utils';

    export default {
        name: 'LiftUpPageBlock',
        props: {
            item: { type: Object, default: () => ({}) },
            rawTitle: { type: String, default: '' },
            rawIngress: { type: String, default: '' },
            industryNames: { type: Array, default: () => [] },
            titleLimit: { type: Number, default: 120 },
            ingressLimit: { type: Number, default: 140 },
            hasImage: { type: Boolean, default: false }
        },
        setup(props) {
            const displayTitle = computed(() =>
                props.rawTitle ? truncText(props.rawTitle, props.titleLimit) : ''
            );
            const displayIngress = computed(() =>
                props.rawIngress ? truncText(props.rawIngress, props.ingressLimit) : ''
            );

            function pushDataLayerEvent(action, url, e) {
                if (e) e.preventDefault();
                if (window?.pushDataLayer) {
                    window.pushDataLayer(action, url, setTimeout(() => (window.location.href = url), 200));
                } else {
                    window.location.href = url;
                }
            }
            return { displayTitle, displayIngress, pushDataLayerEvent };
        }
    };
</script>